<template>
  <div>
    <notifications />

    <!-- Header -->
    <div class="py-7 header bg-gradient-success py-lg-8 pt-lg-9">
      <div class="container">
        <div class="mb-7 text-center header-body">
          <div class="row justify-content-center">
            <div class="px-5 col-xl-5 col-lg-6 col-md-8">
              <h1 class="text-white">Welcome!</h1>
              <p class="text-white text-lead">
                Inventory And Service Management Application
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg
          x="0"
          y="0"
          viewBox="0 0 2560 100"
          preserveAspectRatio="none"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <polygon class="fill-default" points="2560 0 2560 100 0 100" />
        </svg>
      </div>
    </div>
    <!-- Page content -->
    <div class="container pb-5 mt--8">
      <div class="row justify-content-center">
        <div class="col-lg-5 col-md-7">
          <div class="mb-0 border-0 card bg-secondary">
            <div class="card-body px-lg-5 py-lg-5">
              <div class="mb-4 text-center text-muted">
                <small>Sign In With Credentials</small>
              </div>
              <form class="needs-validation" @submit.prevent="checkForm()">
                <!-- <el-form role="form" @submit.prevent.native="signIn"> -->
                <base-input
                  v-model="model.email"
                  alternative
                  :class="{
                    'is-invalid': formErrors.find(i => i.field === 'email')
                  }"
                  class="mb-3"
                  prepend-icon="ni ni-mobile-button"
                  placeholder="Phone Number"
                />

                <!-- class="mb-3" -->
                <base-input
                  v-model="model.password"
                  alternative
                  :class="{
                    'is-invalid': formErrors.find(i => i.field === 'password')
                  }"
                  prepend-icon="ni ni-lock-circle-open"
                  type="password"
                  placeholder="Password"
                />

                <div class="text-center">
                  <base-button type="primary" class="my-4" native-type="submit"
                    >Sign in</base-button
                  >
                </div>
              </form>
            </div>
          </div>
          <div class="mt-3 row">
            <div class="col-6">
              <router-link to="/forgotPassword" class="text-light">
                <small>Forgot password?</small>
              </router-link>
            </div>
            <div class="text-right col-6">
              <router-link to="/register-request" class="text-light">
                <small>Add New Service Request</small>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import { Form, Select, Option } from "element-ui";
import Validator from "@/plugins/customValidator";

export default {
  components: {
    [Form.name]: Form,
    [Select.name]: Select,
    [Option.name]: Option
  },
  data() {
    return {
      model: {
        email: "",
        password: "",
        rememberMe: false
      },
      formErrors: []
    };
  },

  methods: {
    ...mapActions({
      login: "user/login"
    }),
    checkForm() {
      this.formErrors = [];
      const loginErrors = Validator.validateLoginForm(this.model);
      this.formErrors = [...loginErrors];
      if (!this.formErrors.length) {
        this.signIn();
      } else {
        this.formErrors.forEach(i => {
          this.$notify({
            message: i.msg,
            type: "danger",
            title: "Validation Error"
          });
        });
      }
    },
    signIn() {
      this.login(this.model).then(res => {
        if (res === true) {
          this.$notify({
            message: "Logged In Successfully",
            type: "success",
            timeout: 5000,
            icon: "ni ni-bell-55",
            title: "Success"
          });
          this.$router.push("/alternative");
        } else {
          this.$notify({
            message: "Wrong Credential! Please Try Again!",
            type: "danger",
            timeout: 5000,
            icon: "ni ni-bell-55",
            title: "Error"
          });
        }
      });
    }
  }
};
</script>
